// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_mainContainer__ct-f4 {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}
.Table_container__HyjVb {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
.Table_tableContainer__I99ma {
  border: 1px solid #d1d9e2;
  border-radius: 10px;
  overflow: hidden;
}
.Table_table__xPgo3 {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.Table_tableHeaderRow__wPQkA {
  background-color: #f8f9fb;
  height: 44px;
}
.Table_nameSurnameContainer__8dPwn {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-items: baseline;
}
.Table_comment__kuFyy {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
  max-width: 48ch;
}
.Table_nameSurnameHeaderCell__F9ME5 {
  padding: 0px;
  width: 236px;
}
.Table_linkHeaderCell__uAN2N {
  padding: 0px;
  width: 208px;
}
.Table_descriptionHeaderCell__UVIsq {
  padding: 0px;
}
.Table_headerCellLabel__6owgE {
  color: rgba(95, 109, 126, 0.78);
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px 0px 0px 24px;
  text-align: start;
}
.Table_tableDataRow__40ajC {
  border-top: 1px solid #d1d9e2;
  height: 64px;
}
.Table_nameSurnameCell__jE59Y {
  align-items: center;
  column-gap: 16px;
  display: flex;
  height: 64px;
  padding-left: 24px;
  cursor: pointer;
}
.Table_userPhoto__Ci1lJ {
  border-radius: 64px;
  height: 32px;
  width: 32px;
}
.Table_emptyProfilePhoto__OSSFv {
  align-items: center;
  background-color: #e2e2e2;
  border-radius: 64px;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}
.Table_profilePhotoIcon__41tQE {
  stroke: #5f6d7e;
}
.Table_nameSurnameText__qJ1um,
.Table_nameSurnameContainer__8dPwn {
  color: #2e3646;
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  margin: 0px;
  text-transform: capitalize;
  cursor: pointer;
}
.Table_tableLinkCell__93qYn {
  padding-left: 24px;
}
.Table_tableLinkText__uJoWx {
  color: #5f6d7e;
  cursor: pointer;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  margin: 0px;
  text-align: left;
  text-decoration: underline;
}
.Table_tableDescriptionCell__VOa1c {
  padding-left: 24px;
}
.Table_tableDescriptionText__K3mle {
  color: #5f6d7e;
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  margin: 0px;
  text-align: left;
}
.Table_tableSupervisorCell__A1Qwa {
  padding-left: 24px;
}
.Table_tableSupervisorText__DQGYn {
  color: #2e3646;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-align: left;
}
.Table_exportButton__rRP1i {
  align-items: center;
  align-self: flex-end;
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  column-gap: 8px;
  cursor: pointer;
  display: flex;
  height: 40px;
  padding: 0px 16px;
  text-decoration: none;
  margin-top: 1.5rem;
}
.Table_exportButtonIcon__ZMycT {
  fill: #5f6d7e;
  stroke: #5f6d7e;
}
.Table_exportButtonText__OAItZ {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.Table_csvLink__vb5ay {
  display: flex;
}

@media screen and (max-width: 900px) {
  .Table_container__HyjVb {
    justify-content: center;
    align-items: center;
  }
  .Table_table__xPgo3 {
    min-width: 790px;
  }
  .Table_tableContainer__I99ma {
    overflow: scroll;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/documents/components/enrollmentApplications/components/table/Table.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF","sourcesContent":[".mainContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 40px;\n}\n.container {\n  display: flex;\n  flex-direction: column;\n  row-gap: 16px;\n}\n.tableContainer {\n  border: 1px solid #d1d9e2;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n.tableHeaderRow {\n  background-color: #f8f9fb;\n  height: 44px;\n}\n.nameSurnameContainer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  justify-items: baseline;\n}\n.comment {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n  white-space: normal;\n  overflow: hidden;\n  max-width: 48ch;\n}\n.nameSurnameHeaderCell {\n  padding: 0px;\n  width: 236px;\n}\n.linkHeaderCell {\n  padding: 0px;\n  width: 208px;\n}\n.descriptionHeaderCell {\n  padding: 0px;\n}\n.headerCellLabel {\n  color: rgba(95, 109, 126, 0.78);\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px 0px 0px 24px;\n  text-align: start;\n}\n.tableDataRow {\n  border-top: 1px solid #d1d9e2;\n  height: 64px;\n}\n.nameSurnameCell {\n  align-items: center;\n  column-gap: 16px;\n  display: flex;\n  height: 64px;\n  padding-left: 24px;\n  cursor: pointer;\n}\n.userPhoto {\n  border-radius: 64px;\n  height: 32px;\n  width: 32px;\n}\n.emptyProfilePhoto {\n  align-items: center;\n  background-color: #e2e2e2;\n  border-radius: 64px;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  width: 32px;\n}\n.profilePhotoIcon {\n  stroke: #5f6d7e;\n}\n.nameSurnameText,\n.nameSurnameContainer {\n  color: #2e3646;\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  margin: 0px;\n  text-transform: capitalize;\n  cursor: pointer;\n}\n.tableLinkCell {\n  padding-left: 24px;\n}\n.tableLinkText {\n  color: #5f6d7e;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  margin: 0px;\n  text-align: left;\n  text-decoration: underline;\n}\n.tableDescriptionCell {\n  padding-left: 24px;\n}\n.tableDescriptionText {\n  color: #5f6d7e;\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  margin: 0px;\n  text-align: left;\n}\n.tableSupervisorCell {\n  padding-left: 24px;\n}\n.tableSupervisorText {\n  color: #2e3646;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  text-align: left;\n}\n.exportButton {\n  align-items: center;\n  align-self: flex-end;\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  column-gap: 8px;\n  cursor: pointer;\n  display: flex;\n  height: 40px;\n  padding: 0px 16px;\n  text-decoration: none;\n  margin-top: 1.5rem;\n}\n.exportButtonIcon {\n  fill: #5f6d7e;\n  stroke: #5f6d7e;\n}\n.exportButtonText {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.csvLink {\n  display: flex;\n}\n\n@media screen and (max-width: 900px) {\n  .container {\n    justify-content: center;\n    align-items: center;\n  }\n  .table {\n    min-width: 790px;\n  }\n  .tableContainer {\n    overflow: scroll;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `Table_mainContainer__ct-f4`,
	"container": `Table_container__HyjVb`,
	"tableContainer": `Table_tableContainer__I99ma`,
	"table": `Table_table__xPgo3`,
	"tableHeaderRow": `Table_tableHeaderRow__wPQkA`,
	"nameSurnameContainer": `Table_nameSurnameContainer__8dPwn`,
	"comment": `Table_comment__kuFyy`,
	"nameSurnameHeaderCell": `Table_nameSurnameHeaderCell__F9ME5`,
	"linkHeaderCell": `Table_linkHeaderCell__uAN2N`,
	"descriptionHeaderCell": `Table_descriptionHeaderCell__UVIsq`,
	"headerCellLabel": `Table_headerCellLabel__6owgE`,
	"tableDataRow": `Table_tableDataRow__40ajC`,
	"nameSurnameCell": `Table_nameSurnameCell__jE59Y`,
	"userPhoto": `Table_userPhoto__Ci1lJ`,
	"emptyProfilePhoto": `Table_emptyProfilePhoto__OSSFv`,
	"profilePhotoIcon": `Table_profilePhotoIcon__41tQE`,
	"nameSurnameText": `Table_nameSurnameText__qJ1um`,
	"tableLinkCell": `Table_tableLinkCell__93qYn`,
	"tableLinkText": `Table_tableLinkText__uJoWx`,
	"tableDescriptionCell": `Table_tableDescriptionCell__VOa1c`,
	"tableDescriptionText": `Table_tableDescriptionText__K3mle`,
	"tableSupervisorCell": `Table_tableSupervisorCell__A1Qwa`,
	"tableSupervisorText": `Table_tableSupervisorText__DQGYn`,
	"exportButton": `Table_exportButton__rRP1i`,
	"exportButtonIcon": `Table_exportButtonIcon__ZMycT`,
	"exportButtonText": `Table_exportButtonText__OAItZ`,
	"csvLink": `Table_csvLink__vb5ay`
};
export default ___CSS_LOADER_EXPORT___;
